import { getUserTimeZone } from '@griply/utils';

import { useUserQuery } from './queries/use-user-query';

// The zone external-event surfaces read and write in — what the grid paints, what a write declares.
export const useUserTimeZone = (): string => {
  const { data: timezone = getUserTimeZone() } = useUserQuery({
    select: getUserTimeZone,
  });

  return timezone;
};
